import { SelectedPartAction, ServiceProposalPartAction } from "@repo/common"
import {
  addPartAction,
  removePartAction,
  updatePartActionWithSelectedProducts,
  updateProductDecision,
} from "@repo/ui/lib/product-choice-utils"
import { useFieldContext } from "../hooks/form-contexts"
import { ServiceProposalPartActionCard } from "./service-proposal-part-action-card"

export interface ServiceProposalPartActionsFieldProps {
  availableActions: ServiceProposalPartAction[]
  showProductComments?: boolean
}

export const ServiceProposalPartActionsField = ({
  availableActions,
  showProductComments = true,
}: ServiceProposalPartActionsFieldProps) => {
  const field = useFieldContext<SelectedPartAction[]>()

  return (
    <div className="space-y-2">
      {availableActions.map((partActionData) => {
        const selectedAction = field.state.value.find(
          (spa) => spa.partId === partActionData.partId,
        )
        const isSelected = !!selectedAction

        const updatedPartActionData =
          updatePartActionWithSelectedProducts(partActionData)

        const handleSelect = () => {
          // Reception-approved and mandatory actions are locked — the
          // customer cannot toggle them.
          if (
            partActionData.isApprovedViaReception ||
            partActionData.isMandatory
          )
            return
          field.handleChange(
            isSelected
              ? removePartAction(field.state.value, partActionData.partId)
              : addPartAction(
                  field.state.value,
                  partActionData.partId,
                  partActionData.productChoices,
                ),
          )
        }

        const handleProductSelect =
          partActionData.productChoices.length > 0 && selectedAction
            ? (productId: string, choiceId: string) => {
                field.handleChange(
                  updateProductDecision(
                    field.state.value,
                    partActionData.partId,
                    choiceId,
                    productId,
                  ),
                )
              }
            : undefined

        return (
          <ServiceProposalPartActionCard
            key={partActionData.partId}
            data={updatedPartActionData}
            selected={isSelected}
            onSelect={handleSelect}
            onProductSelect={handleProductSelect}
            productDecisions={selectedAction?.productDecisions}
            showProductComments={showProductComments}
          />
        )
      })}
    </div>
  )
}
